<template>
  <Layout>
    <div
      class="max-w-content-container px-small mx-auto w-full pb-24 pt-8 lg:px-14 lg:pb-32 lg:pt-10 2xl:px-0"
    >
      <slot />
    </div>
  </Layout>
</template>
<script setup lang="ts">
/** components */
import Layout from '~/components/TheLayout.vue'
</script>
